export const ID19 = () => {
    return(
        <div>
            <h2 className="servicePage_title">ПЛАНИРОВАНИЕ ТЕХОБСЛУЖИВАНИЯ И РЕМОНТОВ</h2>
            <div className="content" readonly="">
                <div className="txt_block formatted">
                    <h1>1С:ТОИР Управление ремонтами и обслуживанием оборудования</h1>

                    <h3>Ведение списка оборудования</h3>
                    Для ведения списка оборудования в системе предусмотрен иерархический справочник "Объекты ремонта".
                    <div>
                        Глубина и структура дерева произвольная. Обычно отражается производственно-технологическая
                        структура предприятия, до единиц оборудования, требующего
                        планирования и учета ремонтов.<br/>
                        Объекты ремонта и обслуживания – это элементы дерева. Каждый элемент представлен информацией о
                        паспортных данных конкретного объекта ремонта.
                    </div>
                    <h3>Справочники системы</h3>
                    В системе ведутся следующие справочники:
                    <ul>
                        <li>
                            <div>
                                <strong>Виды дефектов</strong>: предназначен для хранения списка возможных видов
                                дефектов используемого на предприятии оборудования. С помощью
                                справочника можно произвести дополнительную классификацию однотипных видов дефектов
                                различных объектов ремонта;
                            </div>
                        </li>
                        <li>
                            <div>
                                <strong>Виды графиков работ</strong>: содержит перечень всех графиков работы предприятия
                                и хранит в себе информацию об объемах рабочего времени
                                по дням и/или сменам. Параметры графика задаются в Помощнике заполнения графика, который
                                позволяет задать общие параметры, и на основании этих
                                параметров автоматически заполнить график работы на очередной год. График можно
                                заполнить по одному из предложенных шаблонов или выполнить
                                настройки вручную;
                            </div>
                        </li>
                        <li>
                            <div>
                                <strong>Ремонтные группы объектов ремонта</strong>: Ремонтная группа - это группа
                                объектов ремонта с одинаковыми нормативными ТО и ремонтами.
                                Ремонтные группы предназначены для упрощения ввода информации о нормативных ремонтах по
                                каждому объекту ремонта и для минимизации размера базы
                                данных системы. Каждая ремонтная группа объединяет в себе нормативные ТО и ремонты для
                                списка однотипных объектов ремонта. Объект ремонта может
                                входить только в какую-либо одну ремонтную группу. Для задания нормативного ремонта в
                                ремонтной группе необходимо установить соответствие между
                                видом ремонта, технологической операцией (с нормативами) и способом планирования этого
                                ремонта. После заполнения списка нормативных ТО и
                                ремонтов необходимо в закладке "Состав ремонтной группы" формы ввода/корректировки
                                ремонтной группы заполнить список однотипных объектов
                                ремонта, для которых указанные ТО и ремонты являются нормативными;
                            </div>
                        </li>
                        <li>
                            <div>
                                <strong>Технологические карты ремонтов</strong>: &nbsp;при вводе технологической карты
                                ремонта указывается перечень технологических операций.
                                Неотъемлемыми реквизитами каждой технологической операции являются
                                материально-техническое обеспечение и обеспечение трудовыми ресурсами, а
                                также РД и Инструкции, регламентирующие данный ремонт.
                            </div>
                        </li>
                        <li>
                            <div>
                                <strong>Паспорт оборудования</strong>: Для каждого объекта ремонта можно указать
                                следующие основные паспортные данные: завод изготовитель, дата
                                выпуска, номер паспорта, заводской номер, технологический номер, инвентарный номер.
                            </div>
                        </li>
                        <li>
                            <div>
                                <strong>Объект ремонта</strong>: для каждого объекта ремонта в системе предусмотрена
                                возможность хранения информации обо всех выполненных
                                ремонтах. Задаются технические характеристики объекта ремонта, предусмотрена возможность
                                ведения учета значений контролируемых показателей
                                оборудования, а также журнала наработки оборудования. Для каждого оборудования
                                уполномоченным сотрудником в систему вносятся значения наработки.
                                Количество видов наработки для каждого объекта не ограничено.
                            </div>
                        </li>
                    </ul>
                    <h3>Планирование ремонтов</h3>
                    Для ведения графиков ППР предназначен список графиков ППР.&nbsp;При вводе графика ППР в системе
                    необходимо указать следующие основные данные:&nbsp;&nbsp;
                    <ul>
                        <li>
                            <div>дату составления графика;</div>
                        </li>
                        <li>
                            <div>период, на который необходимо составить график;</div>
                        </li>
                        <li>
                            <div>организацию, для которой составляется график;</div>
                        </li>
                        <li>
                            <div>подразделение, для которого составляется график;</div>
                        </li>
                        <li>
                            <div>список объектов ремонта, для которых необходимо составить график;</div>
                        </li>
                        <li>
                            <div>перечень видов ТО и ремонтов для каждого объекта ремонта, которые необходимо включить в
                                график.
                            </div>
                        </li>
                    </ul>
                    <div>Для удобства пользователя в системе реализована возможность автоматического подбора группы
                        объектов ремонта.
                    </div>
                    <div>
                        Оперативное планирование ремонтных работ в системе производится в виде ремонтных заявок, в
                        которые можно включать только требуемые материалы и операции,
                        утверждённые в спецификациях и технологических картах. При создании заявок автоматически
                        определяются плановые затраты, а при учёте хода выполнения
                        ремонтов материалы и трудозатраты списываются на конкретный ремонт.
                    </div>
                    <div>Заявка может быть инициирована одним из следующих событий:&nbsp;&nbsp;</div>
                    <ul>
                        <li>
                            <div><strong>Выявленный дефект оборудования</strong> - в этом случае будет сформирована
                                заявка на внеплановый ремонт.
                            </div>
                        </li>
                        <li>
                            <div><strong>Наступление даты планового ремонта по графику ППР</strong> - в этом случае
                                будет сформирована заявка на плановый ремонт.
                            </div>
                        </li>
                    </ul>
                    <div>
                        На основании сформированных заявок на ремонт формируются наряды на выполнение ремонтных работ.
                        Наряд выдается исполнителям (рабочему, бригаде) до начала
                        работы. Наряд заполняется автоматически на основании информации, указанной в заявке, и содержит
                        следующую информацию:
                    </div>
                    <ul>
                        <li>перечень ремонтов и их технологических операций;</li>
                        <li>сроки выполнения работ;</li>
                        <li>перечень ремонтного персонала и его квалификации;</li>
                        <li>расценки;</li>
                        <li>формы оплаты.</li>
                    </ul>
                    <div>
                        Учет выполненных работ в системе осуществляется путем формирования актов выполненных работ. Акт
                        выполненных работ формируется на основании наряда. После
                        ввода и проведения акта выполненных работ затраты МТО и трудозатраты могут быть списаны.
                    </div>
                    <ul>
                        <li>
                            <strong>Обслуживание оборудования</strong>: Под проведением обслуживания понимаются работы,
                            проводимые без остановки оборудования, работы,
                            выполняемые эксплуатационным персоналом. Обычно это работы, включенные в ТО 0, ведение
                            журнала осмотров оборудования, занесения показания счетчиков.
                        </li>
                        <li>
                            <strong>Учет осмотров оборудования</strong>: В системе предусмотрена возможность
                            автоматического составления планов осмотров. Все обнаруженные при
                            осмотрах дефекты: неисправности в работе оборудования, отклонения от нормального состояния
                            оборудования, в том числе не требующие немедленной
                            остановки для их устранения, должны быть зафиксированы эксплуатационным персоналом в Журнале
                            дефектов.
                        </li>
                        <li>
                            <strong>Расчет потребности в МТО</strong>: Для определения потребности в запасных частях,
                            материалах и инструментах на требуемый период в системе
                            должны быть сформированы графики ППР на этот период. На основании информации о планируемых
                            нормативных ТО и ремонтах система автоматически
                            рассчитывает потребность в запасных частях, материалах и инструментах. Информация о
                            потребности в МТО выводится в отчете "План МТО".
                        </li>
                        <li>
                            <strong>Метрология: обслуживание средств измерений</strong>: Все работы по ремонтам и
                            поверке средств измерения отражаются в системе аналогично
                            описанным ремонтам. Для ведения учета значений контролируемых показателей оборудования
                            предназначен документ "Учет контролируемых показателей".
                        </li>
                        <li>
                            <strong>Формирование бюджета на ремонты и техническое обслуживание</strong>: В системе
                            предусмотрена возможность формирования бюджетов на ТО и
                            ремонты и учета затрат. Суммы затрат выводятся в отчете "Прямые затраты на выполнение
                            ремонтов".
                        </li>
                        <li><strong>Контроль затрат МТО</strong>: Для контроля затрат на МТО предназначен отчет
                            "План-фактный анализ затрат МТО".
                        </li>
                        <li><strong>Контроль трудозатрат</strong>: Для контроля затрат на трудовые ресурсы предназначен
                            отчет "План-фактный анализ трудозатрат".
                        </li>
                        <li>
                            <strong>Планирование персонала</strong>: Информация о плановой потребности в персонале
                            выводится в отчете "Плановая занятость сотрудников для
                            ремонтных работ". При работе системы в составе "1С:УПП" доступны все возможности управления
                            персоналом.
                        </li>
                    </ul>
                    <h3>Информация для бухгалтерии</h3>
                    <ul>
                        <li>
                            <strong>Связь с учетом основных средств</strong>: При работе системы в составе "1С:УПП",
                            если объект ремонта является основным средством, необходимо
                            указать это в системе для возможности учета основных средств.
                        </li>
                        <li>
                            <strong>Интеграция с бухгалтерией</strong>: В систему бухгалтерского учета передаются
                            документы для отражения факта ремонта в бухгалтерском учете.
                        </li>
                    </ul>
                    <div>Единая информационная среда – основа EAM системы</div>
                    <br/>
                    Наибольший эффект от применения данного программного продукта достигается при интеграции с типовой
                    конфигурацией "Управление производственным предприятием"
                    («1С:УПП»). Инструкция по интеграции приведена в книге "1С:ТОИР &nbsp;Руководство пользователя",
                    входящей в комплект поставки.
                    <h3>Защита информации, администрирование</h3>
                    Режим содержит перечень настроек, с помощью которых можно более тонко настроить функционирование
                    программы. Внесенные изменения действуют для всех
                    пользователей, зарегистрированных в системе.
                    <div>Для анализа эффективности управления ремонтами в системе можно использовать следующие
                        отчеты:</div>
                    <ul>
                        <li>Отчет по показателям эффективности;</li>
                        <li>План-фактный анализ выполнения работ;</li>
                        <li>План-фактный анализ трудозатрат;</li>
                        <li>План-фактный анализ затрат МТО;</li>
                        <li>Затраты номенклатуры;</li>
                        <li>Текущий анализ данных по состоянию оборудования.</li>
                    </ul>
                    <h3>Технологические достоинства</h3>
                    Использование&nbsp;трехуровневой платформы с комплексным приложением масштаба предприятия, позволяет
                    директору по ИТ и специалистам ИТ-подразделения
                    предприятия быть уверенными в надежности хранения данных, производительности и масштабируемости
                    системы. ИТ-специалисты получают удобный инструмент для
                    реализации задач, необходимых предприятию и сопровождения созданной при внедрении системы.
                    <div>
                        На платформе "1С:Предприятие 8.2" реализовано клиентское приложение – тонкий клиент: он может
                        подключаться по протоколам http или https, при этом вся
                        бизнес-логика реализуется на сервере. Удаленные подразделения могут, используя тонкого клиента,
                        подключаться через Интернет и в on-line режиме работать
                        с информационной базой. Повышается безопасность и скорость работы .
                    </div>
                    <div>
                        На платформе "1С:Предприятие 8.2" реализовано клиентское приложение – Web-клиент: не требует
                        установки на компьютер пользователя никаких компонентов,
                        позволяет использовать на рабочих местах пользователей операционные системы Windows и Linux. Не
                        требует администрирования на компьютерах
                        пользователей.&nbsp;Обеспечивает оперативный доступ к информационной базе для "мобильных"
                        сотрудников.
                    </div>
                    <div>
                        Реализован специальный режим работы клиентских приложений - режим низкой скорости соединения
                        (например, при работе через GPRS, dialup). Можно работать в
                        любой точке, где нет постоянного подключения к Интернету.
                    </div>
                    <div>
                        В режиме управляемого приложения интерфейс не "рисуется", а "описывается". Разработчик
                        определяет только общую схему командного интерфейса и общую схему
                        форм. Это описание платформа использует при построении интерфейса для конкретного пользователя с
                        учетом различных факторов:
                    </div>
                    <ul>
                        <li>прав пользователя;</li>
                        <li>особенностей конкретного внедрения;</li>
                        <li>настроек, сделанных самим пользователем.</li>
                    </ul>
                    <div>Возможно построение индивидуального интерфейса для каждого пользователя.</div>
                    <div>
                        Реализован механизм функциональных опций. Они позволяют включать / выключать необходимые
                        функциональные части конфигурации без изменения самого
                        прикладного решения. Можно подстраивать интерфейс под каждую роль, учитывая предпочтения
                        пользователей.
                    </div>
                    <h3>Масштабируемость и производительность</h3>
                    Использование платформы "1С:Предприятие 8.2" обеспечивает эффективную работу и надежное хранение
                    информации при работе сотен пользователей. Современная
                    трехуровневая архитектура системы дает сохранение высокой производительности при значительном росте
                    нагрузки на систему и объемов обрабатываемых данных.
                    Высокая отказоустойчивость достигается за счет резервирования кластера серверов, а оптимизация
                    быстродействия - за счет динамической балансировки нагрузки
                    между кластерами. Использование СУБД мировых лидеров (MS SQL, IBM DB2, Oracle Database) позволяет
                    строить высокопроизводительные и надежные информационные
                    системы.
                    <div>Построение территориально распределенных систем</div>
                    <br/>
                    В "1С:Предприятии 8" реализован механизм управления распределенными информационными базами, который
                    обеспечивает работу единого прикладного решения
                    (конфигурации) с территориально разнесенными базами данных, объединенными в многоуровневую
                    иерархическую структуру.<br/>
                    <br/>
                </div>
            </div>
        </div>
    )
}